/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { LocationRestService, SystemVarsRestService } from '@gh/builder-shared-data';
import { DictionaryService, globalDictionaries } from '@gh/common-shared';
import { FilteredDataQuery } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import { SystemVarsLocation } from './model/system-vars-location.model';
import {
  SystemVarsFranchisee,
  systemVarsFranchiseeFromDto,
  systemVarsFranchiseeToDto,
} from './model/system-vars.model';

@Injectable()
export class SystemVarsFranchiseeBusinessService {

  constructor(private systemVarsRest: SystemVarsRestService,
              private dictionaryService: DictionaryService,
              private locationRest: LocationRestService) {
  }

  initView(): any {
    return {
      states: this.dictionaryService.get(globalDictionaries.states),
      franchiseeSystemVariables: this.get(),
    };
  }

  /**
   * Returns System Variables Franchisee
   * @returns {Observable<SystemVarsFranchiseeDto>}
   */
  get(): Observable<SystemVarsFranchisee> {
    return this.systemVarsRest.getFranchisee().pipe(map$(systemVarsFranchiseeFromDto));
  }

  /**
   * Modifies System Variables Franchisee
   * @param systemVarsFranchisee
   * @returns {Observable<SystemVarsFranchiseeDto>}
   */
  update(systemVarsFranchisee: SystemVarsFranchisee): Observable<SystemVarsFranchisee> {
    return this.systemVarsRest
      .updateFranchisee(systemVarsFranchiseeToDto(systemVarsFranchisee)).pipe(
        map$(systemVarsFranchiseeFromDto));
  }

  /**
   * Helper method to load locations for city autocomplete
   * @param filter
   * @returns {Observable<SystemVarsLocation[]>}
   */
  findLocations(filter: FilteredDataQuery<string>): Observable<SystemVarsLocation[]> {
    return this.locationRest.findSlicedByCity(filter);
  }
}
